import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {MatDialogRef} from "@angular/material";
import {
    ActionPointsAdvancedSaleChoiceResultsModel
} from "../../../../model/club-gigot/action-points/action-points-advanced-sale-choice-results.model";

@Component({
  selector: 'kt-dialog-advanced-sale-choice',
  templateUrl: './dialog-advanced-sale-choice.component.html',
  styleUrls: ['./dialog-advanced-sale-choice.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DialogAdvancedSaleChoiceComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<DialogAdvancedSaleChoiceComponent>) { }

  ngOnInit() {
  }

    public onNoClick(): void {
        this.dialogRef.close(new ActionPointsAdvancedSaleChoiceResultsModel(true));
    }

    public onSelect(isIndividual: boolean){
      this.dialogRef.close(new ActionPointsAdvancedSaleChoiceResultsModel(false, isIndividual))
    }

}
